<template>
  <dropdown-button class="gs-image-library">
    <span slot="link" class="gs-image-library__trigger">
      <img v-if="selectedSource" class="gs-image-library__selected" :src="selectedSource" alt="Selected design" />
      <span class="gs-image-library__value">{{ value || label }}</span>
      <gs-icon name="chevron-down" size="16" />
    </span>
    <div slot="dropdown" class="gs-image-library__menu">
      <vue-perfect-scrollbar class="gs-image-library__scroll custom-scrollbars">
        <button
          v-for="index in count"
          :key="index"
          type="button"
          class="gs-image-library__item"
          :class="{ 'is-selected': fileName(index) === value }"
          :data-file="fileName(index)"
          :aria-label="fileName(index)" :aria-pressed="fileName(index) === value ? 'true' : 'false'"
          @click="$emit('input', fileName(index))"
        >
          <img :src="source(index)" alt="" />
        </button>
      </vue-perfect-scrollbar>
    </div>
  </dropdown-button>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
  name: 'ImageLibraryPicker',

  components: { VuePerfectScrollbar },

  props: {
    // The file name that is currently stored on the video.
    value: {
      type: String,
      default: '',
    },
    // The images are numbered from 1; this is how many there are.
    count: {
      type: Number,
      required: true,
    },
    // `require.context` over the folder that holds them, created by the owning
    // section: webpack needs that call to carry a static path, so it cannot be
    // made here. Called with `./<file name>`.
    assetPath: {
      type: Function,
      required: true,
    },
    // File name for image *n*, with `{n}` standing in for the number.
    pattern: {
      type: String,
      required: true,
    },
    // Shown on the trigger while nothing is chosen.
    label: {
      type: String,
      default: '',
    },
  },

  computed: {
    selectedSource() {
      try { return this.value ? this.assetPath(`./${this.value}`) : ''; } catch (error) { return ''; }
    },
  },
  methods: {
    fileName(index) {
      return this.pattern.replace('{n}', index);
    },

    source(index) {
      return this.assetPath(`./${this.fileName(index)}`);
    },
  },
};
</script>

<style scoped>
.gs-image-library__selected { height: 44px; max-width: 120px; object-fit: contain; background: #202333; border-radius: 4px; padding: 4px; }
.gs-image-library {
  display: block;
  width: 100%;
}

.gs-image-library__trigger {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 40px;
  padding: 8px 12px;
  color: var(--gs-foreground);
  background: var(--gs-input);
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-md);
  font-size: 14px;
  cursor: pointer;
}

.gs-image-library__value {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.gs-image-library__menu {
  width: 100%;
  background: var(--gs-surface);
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-md);
  box-shadow: var(--gs-shadow-md);
}

.gs-image-library__scroll {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  max-height: 210px;
  padding: 8px;
  overflow-y: auto;
}

.gs-image-library__item {
  padding: 6px;
  background: none;
  border: 1px solid transparent;
  border-radius: var(--gs-radius-sm);
  cursor: pointer;
}

.gs-image-library__item:hover {
  background: var(--gs-muted);
}

.gs-image-library__item.is-selected {
  background: var(--gs-active-soft);
  border-color: var(--gs-active-border);
}

.gs-image-library__item img {
  display: block;
  width: auto;
  height: 52px;
  object-fit: cover;
}

/* The legacy dropdown trigger is an inline block by default. */
.gs-image-library ::v-deep .inline-block {
  display: flex;
  width: 100%;
}
</style>
